/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Time_Just_NowInputs */

const en_time_just_now = /** @type {(inputs: Time_Just_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`just now`)
};

const de_time_just_now = /** @type {(inputs: Time_Just_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gerade eben`)
};

/**
* | output |
* | --- |
* | "just now" |
*
* @param {Time_Just_NowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const time_just_now = /** @type {((inputs?: Time_Just_NowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Time_Just_NowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_time_just_now(inputs)
	return en_time_just_now(inputs)
});